<template>
	<section class="itv-catalog">
		<loader v-if="filtersIsLoading || listIsLoading" />
		<div class="itv-vacancies__container">
			<breadcrumbs class="itv-catalog__breadcrumbs" :content="breadcrumbs" />
			<page-title class="itv-catalog__title" :content="title" />
			<search
				v-if="RENDER"
				@change-event="searchHandler"
				:code="search.code"
				:param-name="'query'"
				:placeholder="search.placeholder"
			/>
			<div class="itv-catalog__container">
				<div class="itv-catalog__filters-wrap">
					<filters
						v-if="filters && RENDER"
						class="itv-catalog__filters"
						@change-event="filtersHandler"
						@update-fields="updateFields"
						:content="filters.data"
					/>
				</div>
				<div class="itv-catalog__catalog">
					<vacancies-list
						v-if="list"
						:count="list.nav.total"
						:pages="[list.nav['page-number'], list.nav['page-count']]"
						:list="list.data"
						@showMore="showMoreHandler"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Breadcrumbs from './components/Breadcrumbs'
import PageTitle from './components/PageTitle'
import Search from './components/Search'
import Filters from './components/Filters'
import VacanciesList from './components/VacanciesList'
import Loader from '@/js/vue-components/Loader'

import { filtersActionTypes } from '../../store/modules/vacancies/filters.js'
import { listActionTypes } from '../../store/modules/vacancies/list.js'
import { mapState } from 'vuex'

export default {
	name: 'Catalog',
	components: {
		Breadcrumbs,
		PageTitle,
		Search,
		Filters,
		VacanciesList,
		Loader,
	},
	data() {
		return {
			RENDER: true,
			PAGE_COUNT: 1,
			urlSearch: new URLSearchParams(window.location.search),
			apiList: '/api/v2/content/career/vacancies/list/',
			apiFilters: '/api/v2/content/career/vacancies/filters/',
			search: {
				placeholder: '',
				code: '',
			},
			params: {
				city: '',
				department: '',
				intern: '',
				type: '',
				query: '',
				page: 1,
			},
			breadcrumbs: null,
			title: 'Поиск по вакансиям',
		}
	},
	computed: {
		...mapState({
			filtersIsLoading: state => state.vacanciesFilters.isLoading,
			filters: state => state.vacanciesFilters.data,
			filtersError: state => state.vacanciesFilters.error,
			listIsLoading: state => state.vacanciesList.isLoading,
			list: state => state.vacanciesList.data,
			vacanciesError: state => state.vacanciesList.error,
		}),
	},
	methods: {
		forceRender() {
			this.RENDER = false
			this.$nextTick(() => {
				this.RENDER = true
			})
		},

		searchHandler(val) {
			this.params.query = val
			this.getList()
		},

		filtersHandler(val, id, activeItems) {
			if (id === 'reset') {
				Object.entries(this.params).forEach(el => {
					this.params[el[0]] = ''
				})

				this.pushHistory()
				this.forceRender()
			}

			if (id === 'intern') {
				this.params[id] = val ? 'Y' : ''
			} else {
				this.params[id] = val
			}

			this.getFilters()
			this.getList()
		},

		updateFields(fields = []) {
			const emptySelectsParam = Object.keys(this.params)
				.filter(el => {
					if (el === 'intern' || el === 'query' || el === 'page') return
					return el
				})
				.filter(el => !fields.includes(el))

			emptySelectsParam.forEach(el => {
				this.params[el] = ''
			})
		},

		paramsToString(type) {
			let filteredParams = Object.entries(this.params).filter(el => el[1])

			if (type === 'history') {
				filteredParams = filteredParams.filter(el => el[0] !== 'page')
			}

			if (type === 'filters') {
				filteredParams = filteredParams.filter(
					el => el[0] === 'type' || el[0] === 'intern'
				)
			}

			if (filteredParams.length !== 0) {
				return `?${filteredParams.map(el => `${el[0]}=${el[1]}`).join('&')}`
			}

			return ''
		},

		getList() {
			this.params.page = this.PAGE_COUNT
			this.$store
				.dispatch(listActionTypes.getList, {
					apiUrl: this.apiList,
					listValue: this.paramsToString(),
				})
				.then(response => {
					this.pushHistory()
				})
		},

		getFilters() {
			this.params.page = this.PAGE_COUNT
			this.$store.dispatch(filtersActionTypes.getFilters, {
				apiUrl: this.apiFilters,
				filtersValue: this.paramsToString('filters'),
			})
		},

		showMoreHandler() {
			this.params.page += this.PAGE_COUNT
			this.$store
				.dispatch(listActionTypes.getMore, {
					apiUrl: this.apiList,
					listValue: this.paramsToString(),
				})
				.then(response => {
					this.pushHistory()
				})
		},

		pushHistory() {
			history.pushState(
				null,
				null,
				`${window.location.href.split('?')[0]}${this.paramsToString('history')}`
			)
		},

		getHistoryParams(key) {
			return this.urlSearch.get(key)
		},
	},
	created() {
		Object.keys(this.params).forEach(el => {
			if (this.getHistoryParams(el)) {
				this.params[el] = this.getHistoryParams(el)
			}
		})

		// костыль обратной совместимости
		if (
			this.getHistoryParams('onlyIT') &&
			this.getHistoryParams('onlyIT') === 'Y'
		)
			this.params.type = 'it'
		// end костыль обратной совместимости

		const main = document.querySelector('#vacancies-catalog')
		if (main) {
			const data = JSON.parse(main.getAttribute('data'))

			const { filter, items } = data.catalog
			this.apiFilters = filter.nav.api
			this.apiList = items.nav.api
			this.$store.state.vacanciesFilters.data = filter
			this.$store.state.vacanciesList.data = items

			const { search, breadcrumbs } = data.sections
			this.search.placeholder = search.props.placeholder.value
			this.search.code = search.code
			this.breadcrumbs = breadcrumbs.props
			this.title = data.props.title.value
		}
	},
}
</script>
